module.exports = __webpack_public_path__ + "img/pro-5-gen-landscape-solid.f7941fa.jpg";